import AboutImage from "../../assets/raisulll.png";
import CV from "../../assets/raisulislampaisu714.pdf";
import { HiDownload } from "react-icons/hi";
import data from "./data";
import Card from "../../components/Card";
import "./about.css";

const About = () => {
  return (
    <section id="about" data-aos="fade-in">
      <div className="container about__container">
        <div className="about__left">
          <div className="about__portrait">
            <img src={AboutImage} alt="About" />
          </div>
        </div>
        <div className="about__right">
          <h2>About Me</h2>
          <div className="about__cards">
            {data.map((item) => (
              <Card key={item.id} className="about__card">
                <span className="about__card-icon">{item.icon}</span>
                <h5>{item.title}</h5>
                <small>{item.desc}</small>
              </Card>
            ))}
          </div>

          <p>
            I'm a hard-worker and Dedicated software engineer, skilled in
            JavaScript and Python.I have been programming for the last 5 years
            starting with C++, Python, and at JavaScript.I have created several
            projects using different programming languages and still learning
            and developing applications to teach myself and also to others that
            how to build powerful applications.
          </p>
          <a href={CV} download className="btn primary">
            Download CV <HiDownload />
          </a>
        </div>
      </div>
    </section>
  );
};

export default About;
